'use strict';

module.exports = ['$scope', '$location', '$window', '$http', 'PlantSvc', '$rootScope', function ($scope, $location, $window, $http, PlantSvc, $rootScope) {
    // ------------------
    // Initialization
    // ------------------
    $scope.activities = [];
    $scope.currentPage = $location.search().page || 1;
    $scope.totalPages = 0;
    $scope.pageSize = 15;
    $scope.sort_by = $location.search().sort_by;
    $scope.sort_order = $location.search().sort_order;
    $scope.maxVisiblePages = 7;

    // ------------------
    // helper functions
    // ------------------
    var loadActivity = function () {
        PlantSvc.getFeed($rootScope.plant, {
            page_size: $scope.pageSize,
            page: $scope.currentPage,
            sort_by: $scope.sort_by,
            sort_order: $scope.sort_order
        }).success(function (data) {
            $scope.activities = data.results;
            $scope.totalItems = data.count;
            $scope.totalPages = Math.ceil(data.count / $scope.pageSize);
        });
    };

    // ------------------
    // Scope Functions
    // ------------------
    $scope.changePage = function (page) {
        $location.search('page', page);
    };

    $scope.sort = function (sort_by) {
        $location.search('sort_by', sort_by);

        if ($scope.sort_by == sort_by) {
            var sort_order = $scope.sort_order == 'asc' ? 'desc' : 'asc';
            $location.search('sort_order', sort_order);
        } else {
            $location.search('sort_order', 'asc');
        }
    };

    // ------------------
    // EVENTS
    // ------------------
    $scope.$on('refresh-signal', loadActivity);

    $scope.$on('$locationChangeSuccess', function () {
        if ($location.search().page) {
            $scope.currentPage = $location.search().page;
            loadActivity();
        }
        if ($location.search().sort_order) {
            $scope.sort_order = $location.search().sort_order;
        }
        if ($location.search().sort_by) {
            $scope.sort_by = $location.search().sort_by;
        }
    });

    // ------------------
    // WATCHES
    // ------------------
    $scope.$watchCollection('[sort_order, sort_by]', function (newval, oldval) {
        if (newval != oldval) {
            loadActivity();
        }
    });

    // ------------------
    // Load Dependent Data
    // ------------------
    loadActivity();

}];